import httpClient from "./httpClient";

const authService = {
  login(data) {
    if (localStorage.getItem("token")) {
      localStorage.clear()
    }
    const auth = Buffer.from(
      data.email + ":" + data.password,
      "utf-8"
    ).toString("base64");
    return httpClient.post(
      "/api/adv/auth",data,
      {
        headers: {
          Authorization: `Basic ${auth}`,
        },
      }
    );
  },
  checkToken() {
    return httpClient.get("/api/adv/auth/check");
  },
  exchangeToken(data) {
    return httpClient.post("/api/adv/auth/renew", data);
  },
  recoverPassword(email) {
    return httpClient.post(`/api/adv/account/${email}/password/recovery`);
  },
  createImpersonate(data) {
    return httpClient.post("/api/adv/auth/impersonate", data);
  },
  createRecoveryPassword(data){
    return httpClient.post(`/api/adv/account/${data.email}/password/recovery?isCreation=${data.isCreation}&source=${data.source}`);

  },
  updateRecoveryPassword(data,isLogged,token){
    return httpClient.put(`/api/profil-candidat/connexion-info?isLogged=${isLogged}`,data,{
      headers: {
        Authorization: `Bearer ${token.toString()}`,
      },
    });

  },
  checkAdvNewPasswordToken(token){
      return httpClient.get("/api/adv/auth/check",{
        headers: {
          Authorization: `Bearer ${token.toString()}`,
        },
      });
  },
  getActivationConditions() {
   
    return httpClient.get(`/api/remote-controlled/activation`)
  } 
  
};

export default authService;
